import React, { useEffect, useMemo, useRef, useState } from "react";
import Purchaser from "../../lib/Core/Backend/Controllers/Purchaser";
import CardType from "../../lib/Core/Backend/Controllers/CardType";
import Notify from "../../lib/Utils/Alert";
import ReactNotificationAlert from "react-notification-alert";
import {
	Button,
	Col,
	FormGroup,
	Input,
	Label,
	Modal,
	ModalBody,
	ModalFooter,
	ModalHeader,
	Row,
} from "reactstrap";
import Select from "react-select";
import DataTable from "../Core/DataTable";
import InternalShoppingCart from "../../lib/Core/Backend/Controllers/InternalShoppingCart";
import useCatalogs from "hooks/useCatalogs";
import Utils from "lib/Utils/Utils";
import Spinner from 'react-bootstrap/Spinner';

const dollarUSLocale = Intl.NumberFormat('en-US', {
	style: "currency",
	currency: "USD",
});

const InternalPurchaseOrderForm = (props) => {
	const { token, name, setData,onReferenceValueChange  } = props;
	const {currencies} = useCatalogs();
	const purchaserCtl = useMemo(() => new Purchaser(token), [token]);
	const cardTypeCtl = useMemo(() => new CardType(token), [token]);
	const internalShoppingCartCtl = useMemo(
		() => new InternalShoppingCart(token),
		[token]
	);
    const [apiId,setApiId] = useState('');
	const [cardTypeCatalog, setcardTypeCatalog] = useState([]);
	const [purchasers, setPurchasers] = useState([]);
	const [brands, setBrands] = useState([]);
	const [brandsLoading, setBrandsLoading] = useState(true);
	const [quantityInput, setQuantityInput] = useState(0);
	const [amountInput, setAmountInput] = useState(0);
	const [orderReferenceInput, setOrderReferenceInput] = useState(0);
	const [cardsLoading, setCardsLoading] = useState(true);
	const [cardTypes, setCardTypes] = useState([]);
	const [confirmModal, setConfirmModal] = useState(false);
	const [cardTypeRow, setCardTypeRow] = useState(null);
	const [date, setdate] = useState();
	const [purchaseTotal, setPurchaseTotal] = useState(0);
	const [referenceValue,setReferenceValue] =useState("")
	const [purchaseSubtotal, setPurchaseSubtotal] = useState(0);
	const [currency, setCurrency] = useState('');
	const [platForm,setPlatForm] = useState("Admin")
	const [cardTypeValue,setCardTypeValue] = useState()

	const toggleConfirm = () => setConfirmModal(!confirmModal);
	const purchaser = useRef();
	const alert = useRef();
	const table = useRef();
	const [showAmount, setShowAmount] = useState(false);
	const [loaderOrder, setLoaderOrder] = useState(false);
	const [loaderOrderDelete, setLoaderOrderDelete] = useState(false);
	const brandSelect = useRef();
	const cardTypeSelect = useRef();

	let currentShoppingCartId = 0;

	const header = [
		{ title: "Name", data: "name", sortable: true, searchable: true },
				{
			title: "Discount",
			data: "purchaseDiscount",
			sortable: true,
			searchable: false,
			render: data => Utils.percentFormat(data/100)
		},
		{ title: 'Currency', data: 'currency', sortable: true, searchable: true },
		{
			title: "Fee",
			data: "purchaseFee",
			sortable: true,
			searchable: false,
			render: (data, type, row) =>
			  row.purchaseFeeType === "PERCENTAGE"
				? Utils.percentFormat(data/100)
				: dollarUSLocale.format(data),
		  },		  
		{
			title: "Value",
			data: "amount",
			sortable: true,
			searchable: false,
			render: data => dollarUSLocale.format(data),
		},
		{
			title: "Quantity",
			data: "quantity",
			sortable: true,
			searchable: false,
		},
		{
			title: 'Subtotal Face Value',
			data: 'subtotal',
			sortable: true,
			render: data => dollarUSLocale.format(data),
		},
		{
			title: 'Subtotal',
			data: 'total',
			sortable: true,
			render: data => dollarUSLocale.format(data),
			
		}
	];

	const onRowCreated = (row) => {
		row.classList.add("ncentiva-datatable-row");
	};

	const onDraw = () => {
		if (table.current) {
			table.current.dataTable
				.rows()
				.eq(0)
				.each((i) => {
					const row = table.current.dataTable.row(i);
					const rowData = row.data();
					if (rowData) {
						let child = `<div class="row justify-content-between ml-1" id="order-${rowData.id}-detail" data-loaded="false">
							<div class="col-3" id="brand-${rowData.id}"><div class="row justify-content-center">Loading info...</div></div>
							<div class="col-4" id="cardType-${rowData.id}"><div class="row justify-content-center">Loading info...</div></div>
							<div class="col-3" id="amount-${rowData.id}"><div class="row justify-content-center">Loading info...</div></div>
              <div class="col" id="quantity-${rowData.id}"><div class="row justify-content-center">Loading info...</div></div>
						</div>`;
						row.child(child).hide();
						row.child().addClass("ncentiva-datatable-child-row");
					}
				});

				if(table.current.dataTable.rows().data().toArray().length === 0){
					setPurchaseSubtotal('$0.00')
					setPurchaseTotal('$0.00');
				}
		}
	};

	useEffect(() => {
		purchaserCtl.all((data) => {
			if (data && !data.error) {
				setPurchasers(
					data.map((purchaser) => ({
						value: purchaser.id,
						label: purchaser.name,
					}))
				);
			} else {
				Notify(alert, "danger", data?.errorMessage ?? data.error);
			}
		});
	}, [purchaserCtl]);

	const handlePurchaserChange = (e) => {
		setBrandsLoading(true);
		brandSelect.current.clearValue();
		setBrands([]);
		setReferenceValue("")
		setCardsLoading(true);
		cardTypeSelect.current.clearValue();

		internalShoppingCartCtl.getShoppingCart(
			e.value,
			(data) => {
				if (data && !data.error) {
					setPurchaseSubtotal(dollarUSLocale.format(data.subtotal))
					setPurchaseTotal(dollarUSLocale.format(data.totalAmount));
					let purchaseItems = data.items.map(item => {
						let card = cardTypeCatalog.find(cardtype => cardtype.id === item.giftCardTypeId)
						let currency = currencies.find(currency => currency.id === item.currencyId)
						return {
							...item,
							name: card ? card.productName : `Not available`,
							currency: currency?.code ?? 'N.A.'
						}
					})
					setData(purchaseItems);
					setReferenceValue(data?.orderReference)
					table.current.dataTable.clear().rows.add(purchaseItems).draw();
				}
			});

		purchaserCtl.availableBrands(e.value, (data) => {
			setApiId(e.value);
			if (data && !data.error) {
				let brands = [];

				Object.keys(data.brandList).forEach((brandId, idx) => {
					brands.push({ value: brandId, label: data.brandList[brandId] });
				});

				setBrands(brands.sort((a, b) => a.label.localeCompare(b.label)));
				setBrandsLoading(false);
			} else {
				Notify(alert, "danger", data.errorMessage ?? data.error);
			}
		});
	};

	const handleBrandChange = (e) => {
		setCardsLoading(true);
		cardTypeSelect.current.clearValue();
		const purchaserId = apiId
		if (e) {
			cardTypeCtl.allBySupplierBrand(purchaserId, e.value, (data) => {
				if (data && !data.error) {
					let cardTypesTmp = [];

					Object.keys(data).forEach((cardTypeId, idx) => {
						cardTypesTmp.push({
							value: data[cardTypeId].id,
							label: data[cardTypeId].productName,
							amount: data[cardTypeId].amount,
						});
					});
					let giftData;
					let currencyData = data?.length > 0 && data[0]?.currency;
					setCurrency(currencyData)
					const fetchData = async () => {
						try {
							const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}private/backoffice/purchaser/card/purchaser/${apiId}/gift-cards`, {
								headers: {
									Authorization: `${token}`
								}
							});					
						  const data = await response.json();
						  giftData = data;
						} catch (error) {
							console.error('Error:', error);
						}
					};
					
					fetchData().then(()=>{
						
						const filteredData = cardTypesTmp.filter(item1 =>
							giftData.some(item2 => item1.value === item2.id)
						  );
						  setCardTypes(filteredData);
					  })
                    
					setCardTypes(cardTypesTmp);
					setCardsLoading(false);
				} else {
					Notify(alert, "danger", data.errorMessage ?? data.error);
				}
			});
		}
	};

	const handleCardTypeChange = (e) => {
		setCardTypeValue(e?.value)
		setAmountInput(e?.amount)
		if ((e === null) | (e === undefined)) {
			return;
		}
		setShowAmount(e.amount === 0);
	};

	const handlePurchaseChange = (e) => {
		if (e.target.name === "amount") {
			setAmountInput(parseFloat(e.target.value, 10));
		} else if (e.target.name === "quantity") {
			setQuantityInput(parseInt(e.target.value, 10));
		}
	};
	const handlePurchaseOrder = (e) => {
		const newValue = e.target.value;
		setReferenceValue(newValue);
		onReferenceValueChange(newValue); // Call the callback function to update parent state
	  };

	const addToPurchaseOrder = (e) => {
		setLoaderOrder(true);
		e.preventDefault();

		if (showAmount && amountInput <= 0) {
			Notify(alert, "danger", `Value must be greater than 0`);
			setTimeout(() => {
				setLoaderOrder(false);
			}, 1500);
			return;
		}

		if (quantityInput <= 0) {
			Notify(alert, "danger", `Quantity must be greater than 0`);
			setTimeout(() => {
				setLoaderOrder(false);
			}, 1500);
			return;
		}
		if(cardTypeValue === null || cardTypeValue === undefined){
			Notify(alert,"danger","Please Select Card Type");
			setTimeout(() => {
				setLoaderOrder(false);
			}, 1500);
			return;
		}

		if (currentShoppingCartId === 0) {
			internalShoppingCartCtl.getShoppingCart(
				purchaser.current.getValue()[0].value,
				(data) => {
					if (data && !data.error) {
						setPurchaseSubtotal(dollarUSLocale.format(data.subtotal))
						setPurchaseTotal(dollarUSLocale.format(data.totalAmount));
						currentShoppingCartId = data.id;
						addGiftCardToShoppingCart(
							cardTypeSelect.current.getValue()[0].value,
							amountInput,
							quantityInput,
							referenceValue
													);
						setTimeout(() => {
							setLoaderOrder(false);
						}, 1500);
					} else {
						Notify(alert, "danger", data.errorMessage ?? data.error);
						setTimeout(() => {
							setLoaderOrder(false);
						}, 1500);
					}
				}
			);
		} else {
			addGiftCardToShoppingCart(
				cardTypeSelect.current.getValue()[0].value,
				amountInput,
				quantityInput,
				referenceValue
							);
			setTimeout(() => {
				setLoaderOrder(false);
			}, 1500);
		}
	};

	function addGiftCardToShoppingCart(giftCardTypeId, amount, quantity,referenceValue) {
		const variable = amount === 0;
		internalShoppingCartCtl.addGiftCardToShoppingCart(
			giftCardTypeId,
			amount,
			quantity,
			variable,
			referenceValue,
			
						(data) => {
				if (data && !data.error) {
					setPurchaseSubtotal(dollarUSLocale.format(data.subtotal))
					setPurchaseTotal(dollarUSLocale.format(data.totalAmount));
					let purchaseItems = data.items.map(item => {
						let card = cardTypeCatalog.find(cardtype => cardtype.id === item.giftCardTypeId)
						return {
							...item,
							currency: card.currency,
							name: card ? card.productName : `Not available`
						}
					})
					setData(purchaseItems);
					table.current.dataTable.clear().rows.add(purchaseItems).draw();
				} else {
					let errorMessage = data.errorMessage ?? data.error;
					if (
					  errorMessage &&
					  errorMessage.startsWith("You have reached the maximum quantity per order")
					) {
					  errorMessage = errorMessage.replace(
						/(\d+(\.\d+)?)$/, 
						(match) => `$${match}` 
					  );
					}
					Notify(alert, "danger", errorMessage);
				}
			}
		);
	}

	const removeCardType = (row) => {
		setCardTypeRow(row);
		toggleConfirm();
	};

	function confirmDelete() {
		setLoaderOrderDelete(true)
		const item = cardTypeRow.data();

		internalShoppingCartCtl.deleteItem(item.id, (data) => {
			// if (data && !data.error) {
				toggleConfirm();
				internalShoppingCartCtl.getShoppingCart(
					purchaser.current.getValue()[0].value,
					(data) => {
						if (data && !data.error) {
							setPurchaseSubtotal(dollarUSLocale.format(data.subtotal))
							setPurchaseTotal(dollarUSLocale.format(data.totalAmount));
							let purchaseItems = data.items.map(item => {
								let card = cardTypeCatalog.find(cardtype => cardtype.id === item.giftCardTypeId)
								return {
									...item,
									currency: card.currency,
									name: card ? card.productName : `Not available`
								}
							})
							setData(purchaseItems);
							table.current.dataTable.clear().rows.add(purchaseItems).draw();
						}
					});
				Notify(
					alert,
					"success",
					`Item ${item.name} removed from shopping cart`
				);
				setTimeout(() => {
					setLoaderOrderDelete(false)
				}, 1500);
			// } else {
			// 	Notify(alert, "danger", data.errorMessage ?? data.error);
			// }
		});
	}

	useEffect(() => {
		let today = new Date();
		let dd = String(today.getDate()).padStart(2, "0");
		let mm = String(today.getMonth() + 1).padStart(2, "0");
		let yyyy = today.getFullYear();

		today = mm + "-" + dd + "-" + yyyy;
		setdate(today);
		onDraw()
	}, []);

	useEffect(() => {
		cardTypeCtl.all(data => {
			if(data.error || data.errorMessage){
				setcardTypeCatalog([])
			} else {
				setcardTypeCatalog(data)
			}
		})
	}, [cardTypeCtl]);

	return (
		<>
			<ReactNotificationAlert ref={alert} />
			<Row className="justify-content-center">
				<Col md={5}>
					<legend className="text-center">{name}</legend>
				</Col>
			</Row>
			<Row className="justify-content-center">
				<Col md={5}>
					<legend className="text-center">{date}</legend>
				</Col>
			</Row>
			<Row className="justify-content-center mt-5">
				<Col md="5">
					<FormGroup>
						<Label for="purchaseFormBrand">Purchaser</Label>
						<Select
							id="purchaseFormBrand"
							ref={purchaser}
							options={purchasers}
							onChange={handlePurchaserChange}
						/>
					</FormGroup>
				</Col>
			</Row>
			<Row className="justify-content-center">
				<Col md="5">
					<FormGroup>
						<Label for="purchaseOrderRefernce">Order Reference</Label>
						<Input
							id="purchaserOrder"
							type="text"
							name="amount"
							value={referenceValue}
							onChange={handlePurchaseOrder}
							/>
					</FormGroup>
				</Col>
			</Row>
			<Row className="justify-content-center mt-5">
				<Col md={3}>
					<FormGroup>
						<Label for="purchaseFormBrand">Brand</Label>
						<Select
							id="purchaseFormBrand"
							ref={brandSelect}
							options={brands}
							onChange={handleBrandChange}
							isLoading={brandsLoading}
						/>
					</FormGroup>
				</Col>

				<Col md={1}>
						<FormGroup>
							<Label for="purchaseFormCurrency">Currency</Label>
							<Input
								id="purchaseFormCurrency"
								type="text"
								name="currency"
								value={currency}
							/>
						</FormGroup>
					</Col>

				<Col md={3}>
					<FormGroup>
						<Label for="purchaseFormCardType">Card Type</Label>
						<Select
							id="purchaseFormCardType"
							ref={cardTypeSelect}
							options={cardTypes}
							onChange={handleCardTypeChange}
							isLoading={cardsLoading}
						/>
					</FormGroup>
				</Col>
				{showAmount && (
					<Col md={1}>
						<FormGroup>
							<Label for="purchaseFormAmount">Value</Label>
							<Input
								id="purchaseFormAmount"
								type="number"
								name="amount"
								value={amountInput}
								onChange={handlePurchaseChange}
							/>
						</FormGroup>
					</Col>
				)}

				<Col md={1}>
					<FormGroup>
						<Label for="purchaseFormQuantity">Quantity</Label>
						<Input
							id="purchaseFormQuantity"
							type="number"
							name="quantity"
							value={quantityInput}
							onChange={handlePurchaseChange}
						/>
					</FormGroup>
				</Col>

				<Col md='auto'>
					<FormGroup className="mt-1">
						<Button
							className="mt-4 btn btn-primaryTwo"
							id="add-btn"
							type="button"
							// color="primary"
							onClick={addToPurchaseOrder}
							disabled={loaderOrder}
						>
							{!loaderOrder && "Add"} {loaderOrder && <Spinner
								as="span"
								animation="border"
								size="sm"
								role="status"
								aria-hidden="true"
								style={{
									margin: "0px 8px"
								}}
							/>}
						</Button>
					</FormGroup>
				</Col>
			</Row>
			<Row className="justify-content-center">
				<Col md="10" className="text-center">
					<DataTable
						className="mb-0 no-bottom-radius"
						options={{
						  createdRow: onRowCreated,
						  drawCallback: onDraw,
						  saveState: false,
						  dom: 'tr',
						  pageLength: -1,
						  scrollY: '1vh'
						}}
						ref={table}
						columns={header}
						data={null}
						enableSelectFilters={true}
						addRemoveButton={{ callback: removeCardType, viewMode: false }}
					/>
				</Col>
			</Row>
			<Row className="justify-content-center">
				<div className="col-sm-10">
					<div className="bg-color7 rounded-bottom pr-1" style={{width: "100%", height: "100%"}}>
						<p className="py-3 my-0 mr-5 pr-5 text-right"><span className="mr-4 font-weight-bold">Subtotal</span>{purchaseSubtotal}</p>
						<p className="py-3 my-0 mr-5 pr-5 text-right"><span className="mr-4 font-weight-bold">Total</span>{purchaseTotal}</p>
					</div>
				</div>
			</Row>

			<Modal
				isOpen={confirmModal}
				toggle={toggleConfirm}
				backdrop="static"
				centered={true}
			>
				<ModalHeader className="custom_header_colourTwo" toggle={toggleConfirm}>
					Remove Card Type
				</ModalHeader>
				<ModalBody>
					<p className="card-just-text">
						Are you sure you want to remove the selected card?
					</p>
				</ModalBody>
				<ModalFooter>
					<Button type="button" color="secondary" onClick={toggleConfirm}>
						Cancel
					</Button>{" "}
					<Button type="button" className="btn btn-primaryTwo" onClick={confirmDelete} disabled={loaderOrderDelete}>
						{!loaderOrderDelete && "Yes"}{loaderOrderDelete && <Spinner
							as="span"
							animation="border"
							size="sm"
							role="status"
							aria-hidden="true"
							style={{
							margin: "0px 8px"
							}}
						/>}
					</Button>
				</ModalFooter>
			</Modal>
		</>
	);
};

export default InternalPurchaseOrderForm;